export default {
  issuerConfigurationVariables: [],
  activeVariable: {},
};
